/* NIKITA side cart pendant card (v1, 21 Oct 2026, TEST theme only).
 * Paints an Initial / Star sign card into the UpCart drawer above the Lucky Dip row,
 * only when a standard ear cuff is in the cart and no pendant yet. The price drop comes
 * from the UpCart discount rule NKC-PENDANT-UNLOCK (2 ear cuffs + an Initial/Star sign pendant =
 * £15 off the basket, was £10 until 22 Oct and £9.01 before that; pendants are £30 so this is half price), not from here: the pendant line stays at its full price
 * and the basket shows the discount. OFFER_LIVE true = the rule exists.
 * Shown only when the basket already has MIN_CUFFS ear cuffs, so it never replaces the second cuff.
 * Preview: ?nkc=off hides (session), ?nkc=on shows, ?nkc_price=1 shows the offer price,
 * ?nkc_min=1 shows it for single-cuff baskets too. One-cuff baskets see a locked teaser
 * ("2 ear cuffs for £55, unlock a pendant price") with a 2nd-cuff picker; ?nkc_teaser=off hides it.
 * In an unpublished (preview) theme the offer is shown by default; ?nkc_price=0 hides it. */
(function () {
  'use strict';
  var OFFER_LIVE = true;           // the UpCart rule NKC-PENDANT-UNLOCK is live
  var OFFER_OFF  = 1500;           // pence off a pendant with an ear cuff (must match the discount rule)
  var MIN_CUFFS  = 2;              // show the card only once the basket holds this many ear cuffs
  var TEASER     = true;           // one-cuff baskets see a locked "add a 2nd cuff to unlock" card
  var PAIR_OFF   = 1500;           // pence off the 2nd cuff (must match the 2 EAR CUFFS FOR £55 discount)
  var PLAIN_HANDLE = 'plain-pain-free-hinged-ear-cuff';
  var RHINE_HANDLE = 'rhinestone-pain-free-hinged-ear-cuff';
  var TABS = [
    { key: 'initial', tab: 'Initial',   title: 'Add an initial',      handle: 'initial-pendant-necklace',              pick: 'Choose a letter' },
    { key: 'zodiac',  tab: 'Star sign', title: 'Add a star sign',      handle: 'zodiac-disc-necklace-18k-gold-plated', pick: 'Choose a star sign', goldOnly: true }
  ];
  var ZODIAC = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'];
  var CUFF_SKU_PREFIX   = 'E-Cali';        // standard ear cuffs (Large sizes are outside the bundle discounts)
  var PENDANT_SKU_PREFS = ['P-IN', 'P-Z']; // Initial and Zodiac SKUs: card hides once one is in the cart
  var LINE_PROP = '_nkc';                  // hidden line property so orders can be counted
  var GA = true;
  var FONT = 'Poppins,"Helvetica Neue",Arial,sans-serif';
  var CSS =
    '.nkc{margin:0 0 10px;padding:12px;background:#fff;border:1px solid rgba(21,21,21,.18);border-radius:8px;' +
    'font-family:' + FONT + ';color:#151515;font-size:13px;line-height:1.35;text-align:left}' +
    '.nkc *{box-sizing:border-box;font-family:inherit}' +
    '.nkc-top{display:flex;gap:12px;align-items:center}' +
    '.nkc-img{width:80px;height:80px;object-fit:cover;border-radius:6px;background:#E7E5E1;flex:none}' +
    '.nkc-main{flex:1;min-width:0}' +
    '.nkc-title{font-weight:500;font-size:14px;margin:0 0 2px}' +
    '.nkc-price{margin:0 0 6px}.nkc-price b{font-weight:500}.nkc-price s{color:#868585;margin-left:6px}' +
    '.nkc-tabs{display:flex;border:1px solid #151515;border-radius:6px;overflow:hidden}' +
    '.nkc-tabs button{flex:1;border:0;background:#fff;color:#151515;padding:5px 6px;font-size:11px;letter-spacing:.08em;' +
    'text-transform:uppercase;cursor:pointer;white-space:nowrap}' +
    '.nkc-tabs button[aria-pressed="true"]{background:#151515;color:#fff}' +
    '.nkc-pick{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap}' +
    '.nkc-metal{display:flex;gap:6px;width:100%}' +
    '.nkc-metal button{flex:1;border:1px solid rgba(21,21,21,.35);background:#fff;border-radius:6px;padding:6px 4px;font-size:12px;cursor:pointer;color:#151515}' +
    '.nkc-metal button[aria-pressed="true"]{border-color:#151515;box-shadow:inset 0 0 0 1px #151515;font-weight:500}' +
    '.nkc-sel{flex:1;min-width:120px;border:1px solid #151515;border-radius:6px;background:#fff;color:#151515;padding:8px 8px;font-size:13px}' +
    '.nkc-add{flex:1;min-width:120px;border:0;border-radius:6px;background:#151515;color:#fff;padding:9px 8px;font-size:11px;' +
    'letter-spacing:.1em;text-transform:uppercase;font-weight:500;cursor:pointer}' +
    '.nkc-add[disabled]{opacity:.35;cursor:not-allowed}' +
    '.nkc-metal button.nkc-na{opacity:.4;text-decoration:line-through;cursor:not-allowed}' +
    '.nkc-note{width:100%;font-size:12px;color:#5E5E5E}' +
    '.nkc-msg{margin-top:8px;font-size:12px;color:#9C3E3E}' +
    '.nkc-unlock{display:inline-flex;align-items:center;gap:5px;margin:0 0 5px;padding:2px 9px;border-radius:99px;font-size:10px;letter-spacing:.08em;text-transform:uppercase;font-weight:500;color:#151515}' +
    '.nkc-unlock{background:#D1A1D6}' +
    '.nkc-unlock svg{width:12px;height:12px;flex:none}' +
    '.nkc-teaser{border-color:#151515;box-shadow:inset 0 0 0 1px #151515}' +
    '.nkc-teaser .nkc-img,.nkc-teaser .nkc-imgw{width:88px;height:64px}' +
    '.nkc-teaser .nkc-gem{font-size:10px;letter-spacing:.03em;padding:12px 30px 12px 12px}' +   /* long label: keep it on one line on a phone */
    '.nkc-head{font-size:16px;font-weight:500;line-height:1.25;color:#151515;margin:0 0 3px}' +
    '.nkc-sub2{font-size:13px;line-height:1.4;color:#484848}' +
    '.nkc-gem{display:block;width:100%;margin-top:12px;appearance:none;-webkit-appearance:none;border:0;border-radius:6px;color:#fff;cursor:pointer;text-align:left;padding:12px 38px 12px 14px;font-size:11px;letter-spacing:.1em;text-transform:uppercase;font-weight:500;' +
    'background:#151515 url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%273%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><path d=%27M6 9l6 6 6-6%27/></svg>") no-repeat right 12px center / 16px}' +
    '.nkc-gem option{color:#151515;background:#fff;text-transform:none;letter-spacing:0;font-size:14px}' +
    '.nkc-gem[disabled]{opacity:.6;cursor:wait}' +
    '.nkc-imgw{position:relative;flex:none;width:80px;height:80px}' +
    '.nkc-unlocked{border-color:#D1A1D6;box-shadow:inset 0 0 0 1px #D1A1D6}' +
    '@keyframes nkcpop{0%{transform:scale(.97);box-shadow:0 0 0 0 rgba(209,161,214,.9)}40%{transform:scale(1.015);box-shadow:0 0 0 7px rgba(209,161,214,.45)}100%{transform:scale(1);box-shadow:inset 0 0 0 1px #D1A1D6}}' +
    '.nkc-new{animation:nkcpop .9s ease-out 1}' +
    '@media (prefers-reduced-motion:reduce){.nkc-new{animation:none}}' +
    '.nkc-tag{display:inline-block;margin-left:6px;padding:1px 6px;border:1px dashed #868585;border-radius:99px;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:#5E5E5E}';
  var st = { cart: null, plain: null, loadingPlain: false, rhine: null, loadingRhine: false, prevMode: '', unlockAt: 0, data: {}, loading: {}, tab: 'initial', metal: '', pick: '', msg: '', adding: false, viewedFor: '' };
  var paintTimer = null;
  var params = (function () { try { return new URLSearchParams(location.search); } catch (e) { return null; } })();
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} return null; }
  if (params && params.get('nkc') === 'off') ss('nkc_off', '1');
  if (params && params.get('nkc') === 'on') ss('nkc_off', null);
  function disabled() { return ss('nkc_off') === '1' || !(window.Shopify && Shopify.currency && Shopify.currency.active === 'GBP'); }
  function previewPrice() {
    var q = params && params.get('nkc_price');
    if (q === '1') return true;
    if (q === '0') return false;
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    return !!role && role !== 'main';          // unpublished test copies show the offer so it can be reviewed
  }
  function showOffer() { return OFFER_LIVE || previewPrice(); }
  function ga(name, extra) {
    if (!GA || typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, extra || {}); } catch (e) {}
  }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function whole(p) { return p % 100 === 0 ? '£' + (p / 100) : money(p); }
  function root() { var h = document.getElementById('upCart'); return (h && h.shadowRoot) ? h.shadowRoot : null; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { st.cart = c; return c; }).catch(function () { return st.cart; });
  }
  function icon(kind) {
    var NS = 'http://www.w3.org/2000/svg', s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2.4'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round'); s.setAttribute('aria-hidden', 'true');
    function add(tag, attrs) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); s.appendChild(n); }
    if (kind === 'lock') { add('rect', { x: 5, y: 11, width: 14, height: 9, rx: 2 }); add('path', { d: 'M8 11V8a4 4 0 0 1 8 0v3' }); }
    else add('path', { d: 'M5 12.5l4.5 4.5L19 7.5' });
    return s;
  }
  function cuffCount(c) {
    return c ? c.items.reduce(function (n, i) { var s = i.sku || ''; return n + ((s.indexOf(CUFF_SKU_PREFIX) === 0 && s.toLowerCase().indexOf('large') < 0) ? i.quantity : 0); }, 0) : 0;
  }
  function minCuffs() { var p = params && parseInt(params.get('nkc_min'), 10); return p > 0 ? p : MIN_CUFFS; }
  function hasPendant(c) {
    return !!(c && c.items.some(function (i) { var s = i.sku || ''; return PENDANT_SKU_PREFS.some(function (p) { return s.indexOf(p) === 0; }); }));
  }
  function mode() {
    if (disabled() || !st.cart || hasPendant(st.cart)) return '';
    var n = cuffCount(st.cart);
    if (n >= minCuffs()) return 'card';
    if (TEASER && n >= 1 && !(params && params.get('nkc_teaser') === 'off')) return 'teaser';
    return '';
  }
  function cuffMetal(c) {
    var it = c.items.filter(function (i) { return (i.sku || '').indexOf(CUFF_SKU_PREFIX) === 0 && (i.sku || '').toLowerCase().indexOf('large') < 0; })[0];
    return it && (it.sku.split('-')[2] === 's') ? 's' : 'g';
  }
  function loadPlain() {
    if (st.plain || st.loadingPlain) return;
    st.loadingPlain = true;
    fetch('/products/' + PLAIN_HANDLE + '.js').then(function (r) { if (!r.ok) throw new Error('no product'); return r.json(); })
      .then(function (p) {
        st.plain = { vars: p.variants.filter(function (v) { return v.available; }).map(function (v) { return { id: v.id, price: v.price, metal: /silver/i.test(v.option1 || v.title) ? 's' : 'g', metalName: v.option1 || '' }; }) };
        st.loadingPlain = false; schedule();
      }).catch(function () { st.plain = { vars: [] }; st.loadingPlain = false; schedule(); });
  }
  function optIndex(p, name) {
    for (var i = 0; i < p.options.length; i++) {
      var n = typeof p.options[i] === 'string' ? p.options[i] : p.options[i].name;
      if (String(n).toLowerCase() === name) return i + 1;
    }
    return 0;
  }
  function loadProduct(t) {
    if (st.data[t.key] || st.loading[t.key]) return;
    st.loading[t.key] = true;
    fetch('/products/' + t.handle + '.js').then(function (r) { if (!r.ok) throw new Error('no product'); return r.json(); })
      .then(function (p) {
        var feat = String(p.featured_image || '').replace(/^\/\//, 'https://');
        var custom = (t.key === 'initial' && window.NKC_INITIAL_IMG) ? String(window.NKC_INITIAL_IMG).replace(/^\/\//, 'https://') : '';
        var metalIdx = optIndex(p, 'metal'), pickIdx = optIndex(p, t.key === 'initial' ? 'initial' : 'star sign');
        var vars = p.variants.filter(function (v) { return v.available; }).map(function (v) {
          return { id: v.id, price: v.price, cmp: v.compare_at_price || 0, metal: metalIdx ? v['option' + metalIdx] : '', pick: pickIdx ? v['option' + pickIdx] : v.title };
        });
        st.data[t.key] = { title: p.title, image: custom || feat, fallback: feat, vars: vars };
        st.loading[t.key] = false; schedule();
      }).catch(function () { st.data[t.key] = { vars: [] }; st.loading[t.key] = false; schedule(); });
  }
  function loadRhine() {
    if (st.rhine || st.loadingRhine) return;
    st.loadingRhine = true;
    fetch('/products/' + RHINE_HANDLE + '.js').then(function (r) { if (!r.ok) throw new Error('no product'); return r.json(); })
      .then(function (p) {
        var mi = optIndex(p, 'metal'), ci = optIndex(p, 'colour');
        st.rhine = { vars: p.variants.map(function (v) { return { id: v.id, price: v.price, avail: v.available, metal: /silver/i.test(v['option' + mi] || '') ? 's' : 'g', metalName: v['option' + mi] || '', colour: v['option' + ci] || v.title }; }) };
        st.loadingRhine = false; schedule();
      }).catch(function () { st.rhine = { vars: [] }; st.loadingRhine = false; schedule(); });
  }
  function tabInfo(key) { return TABS.filter(function (t) { return t.key === key; })[0]; }
  function metals(d) { var m = []; d.vars.forEach(function (v) { if (v.metal && m.indexOf(v.metal) < 0) m.push(v.metal); }); return m; }
  function picks(d, metal) {
    var list = d.vars.filter(function (v) { return !metal || v.metal === metal; }).map(function (v) { return v.pick; });
    var seen = {}; list = list.filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; });
    if (/^[A-Z]$/.test(list[0] || '')) list.sort();
    else if (list.some(function (x) { return ZODIAC.indexOf(x) > -1; })) list.sort(function (x, y) { return ZODIAC.indexOf(x) - ZODIAC.indexOf(y); });
    return list;
  }
  function variantFor(d, metal, pick) {
    return d.vars.filter(function (v) { return v.pick === pick && (!metal || v.metal === metal); })[0] || null;
  }
  function metalLabel(m) { return /silver/i.test(m) ? 'Silver' : (/gold/i.test(m) ? 'Gold' : m); }
  function sig() {
    return [mode(), st.plain ? st.plain.vars.length : '-', st.rhine ? st.rhine.vars.length : '-', st.tab, st.metal, st.pick, st.msg, st.adding, showOffer(), TABS.map(function (t) { var d = st.data[t.key]; return d ? d.vars.length : '-'; }).join(',')].join('|');
  }
  function build() {
    var unlocked = TEASER && minCuffs() >= 2 && showOffer();
    var age = st.unlockAt ? Date.now() - st.unlockAt : 9999, pop = unlocked && age < 900;
    var card = el('div', 'nkc' + (unlocked ? ' nkc-unlocked' : '') + (pop ? ' nkc-new' : ''));
    if (pop) card.style.animationDelay = '-' + age + 'ms';   // a redraw mid-animation carries on from where it was
    card.id = 'nkc-card'; card.setAttribute('role', 'group'); card.setAttribute('aria-label', 'Add a pendant to your order');
    var avail = TABS.filter(function (t) { return st.data[t.key] && st.data[t.key].vars.length; });
    if (!avail.length) return null;
    if (!avail.some(function (t) { return t.key === st.tab; })) st.tab = avail[0].key;
    var t = tabInfo(st.tab), d = st.data[t.key];
    var ms = metals(d); if (!ms.length) st.metal = ''; else if (ms.indexOf(st.metal) < 0) st.metal = ms[0];
    var ps = picks(d, st.metal); if (st.pick && ps.indexOf(st.pick) < 0) st.pick = '';
    var v = variantFor(d, st.metal, st.pick) || d.vars[0];
    var top = el('div', 'nkc-top');
    var img = el('img', 'nkc-img'); img.alt = ''; img.src = d.image || '';
    img.onerror = function () { if (d.fallback && img.src !== d.fallback) img.src = d.fallback; };
    var main = el('div', 'nkc-main');
    if (unlocked) { var up = el('span', 'nkc-unlock'); up.appendChild(icon('check')); up.appendChild(document.createTextNode('Unlocked: ' + whole(OFFER_OFF) + ' off')); main.appendChild(up); }
    main.appendChild(el('div', 'nkc-title', t.title));
    var pr = el('div', 'nkc-price');
    pr.appendChild(el('b', null, whole(showOffer() ? v.price - OFFER_OFF : v.price)));
    if (showOffer()) pr.appendChild(el('s', null, whole(v.price)));
    if (v.cmp > v.price) pr.appendChild(el('s', null, whole(v.cmp)));
    if (showOffer() && !OFFER_LIVE) pr.appendChild(el('span', 'nkc-tag', 'Preview'));
    main.appendChild(pr);
    if (showOffer()) main.appendChild(el('div', 'nkc-note', whole(OFFER_OFF) + ' is taken off, in your basket'));
    if (avail.length > 1) {
      var tabs = el('div', 'nkc-tabs');
      avail.forEach(function (x) {
        var bt = el('button', null, x.tab); bt.type = 'button'; bt.setAttribute('aria-pressed', x.key === st.tab ? 'true' : 'false');
        bt.addEventListener('click', function () { if (st.tab === x.key) return; st.tab = x.key; st.pick = ''; st.msg = ''; ga('nkc_tab_click', { tab: x.key }); schedule(true); });
        tabs.appendChild(bt);
      });
      main.appendChild(tabs);
    }
    top.appendChild(img); top.appendChild(main); card.appendChild(top);
    var pick = el('div', 'nkc-pick');
    if (ms.length > 1) {
      var mw = el('div', 'nkc-metal');
      ms.forEach(function (m) {
        var bt = el('button', null, metalLabel(m)); bt.type = 'button'; bt.setAttribute('aria-pressed', m === st.metal ? 'true' : 'false');
        bt.addEventListener('click', function () { st.metal = m; st.msg = ''; schedule(true); });
        mw.appendChild(bt);
      });
      pick.appendChild(mw);
    } else if (t.goldOnly) {
      var gw = el('div', 'nkc-metal');
      var gb = el('button', null, 'Gold'); gb.type = 'button'; gb.setAttribute('aria-pressed', 'true');
      var sb = el('button', 'nkc-na', 'Silver'); sb.type = 'button'; sb.disabled = true; sb.setAttribute('aria-label', 'Silver, not available');
      gw.appendChild(gb); gw.appendChild(sb); pick.appendChild(gw);
      pick.appendChild(el('div', 'nkc-note', 'Star sign pendants are gold only. Not available in silver.'));
    }
    var sel = el('select', 'nkc-sel'); sel.setAttribute('aria-label', t.pick);
    var o0 = el('option', null, t.pick); o0.value = ''; sel.appendChild(o0);
    ps.forEach(function (x) { var o = el('option', null, x); o.value = x; if (x === st.pick) o.selected = true; sel.appendChild(o); });
    /* iOS Safari reopens a <select> that is focused programmatically, so a letter pick must not redraw the card and refocus it:
       blur the list and just enable the button; redraw only to clear an error message. */
    sel.addEventListener('change', function () {
      var hadMsg = !!st.msg; st.pick = sel.value; st.msg = '';
      try { sel.blur(); } catch (e) {}
      if (hadMsg) { schedule(true); return; }
      add.disabled = !st.pick || st.adding; lastSig = sig();
    });
    pick.appendChild(sel);
    var add = el('button', 'nkc-add', st.adding ? 'Adding...' : 'Add to my order'); add.type = 'button';
    add.disabled = !st.pick || st.adding;
    add.addEventListener('click', function () { addToCart(t, d); });
    pick.appendChild(add);
    card.appendChild(pick);
    if (st.msg) { var m = el('div', 'nkc-msg', st.msg); m.setAttribute('role', 'status'); card.appendChild(m); }
    return card;
  }
  function buildTeaser() {
    var init = st.data.initial; if (!init || !init.vars.length || !st.plain || !st.rhine) return null;
    var metal = cuffMetal(st.cart);
    var opts = st.rhine.vars.filter(function (v) { return v.metal === metal && v.avail; }).map(function (v) { return { id: v.id, price: v.price, label: v.colour, metalName: v.metalName }; });
    var plain = st.plain.vars.filter(function (v) { return v.metal === metal; })[0];
    if (plain) opts.push({ id: plain.id, price: plain.price, label: 'Plain', metalName: plain.metalName });
    if (!opts.length) return null;
    var first = st.cart.items.filter(function (i) { var k = i.sku || ''; return k.indexOf(CUFF_SKU_PREFIX) === 0 && k.toLowerCase().indexOf('large') < 0; })[0];
    var p1 = (first && first.original_price) || opts[0].price, ip = init.vars[0].price;
    var card = el('div', 'nkc nkc-teaser'); card.id = 'nkc-card'; card.setAttribute('role', 'group'); card.setAttribute('aria-label', 'Add a 2nd ear cuff and unlock a pendant price');
    var top = el('div', 'nkc-top');
    var img = el('img', 'nkc-img'); img.alt = '';
    var duo = window.NKC_DUO_IMG ? String(window.NKC_DUO_IMG).replace(/^\/\//, 'https://') : '';   /* real photos of an initial and a star sign, side by side */
    img.src = duo || init.image || '';
    img.onerror = function () { if (init.fallback && img.src !== init.fallback) img.src = init.fallback; };
    var iw = el('div', 'nkc-imgw'); iw.appendChild(img); top.appendChild(iw);
    var main = el('div', 'nkc-main');
    main.appendChild(el('div', 'nkc-head', 'Add a 2nd ear cuff and save ' + whole(PAIR_OFF)));
    main.appendChild(el('div', 'nkc-sub2', showOffer()
      ? (OFFER_OFF * 2 === ip   /* "half price" only while the discount really is half */
          ? 'Also unlock an initial or star sign necklace for half price! (Usually ' + whole(ip) + ')'
          : 'Also unlock an initial or star sign necklace for ' + whole(ip - OFFER_OFF) + ' (usually ' + whole(ip) + ')')
      : 'Also unlock a discount on an initial or star sign necklace'));
    top.appendChild(main); card.appendChild(top);
    var sel = el('select', 'nkc-gem'); sel.setAttribute('aria-label', 'Choose your 2nd ear cuff');
    var o0 = el('option', null, st.adding ? 'Adding...' : 'Choose 2nd cuff & unlock discount'); o0.value = ''; sel.appendChild(o0);
    opts.forEach(function (o) { var op = el('option', null, o.label + ', ' + (o.metalName || (metal === 's' ? 'Stainless Steel - Silver Plated' : 'Gold - 18k Plated')) + ', ' + money(o.price - PAIR_OFF)); op.value = o.id; sel.appendChild(op); });
    sel.disabled = st.adding;
    sel.addEventListener('change', function () {
      var id = parseInt(sel.value, 10); if (!id) return;
      var v = opts.filter(function (x) { return x.id === id; })[0]; if (v) addCuff(v);
    });
    card.appendChild(sel);
    if (st.msg) { var m = el('div', 'nkc-msg', st.msg); m.setAttribute('role', 'status'); card.appendChild(m); }
    return card;
  }
  function addCuff(v) {
    if (st.adding) return;
    st.adding = true; st.msg = ''; schedule(true);
    var props = {}; props[LINE_PROP] = 'teaser';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        st.adding = false;
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'add failed');
        ga('nkc_teaser_add', { variant_id: v.id, colour: v.label, price: v.price });
        return loadCart().then(function () {
          if (typeof window.upcartRefreshCart === 'function') { try { return window.upcartRefreshCart(); } catch (e) {} }
        });
      })
      .then(function () { schedule(true); })
      .catch(function (e) {
        st.adding = false; st.msg = 'Sorry, that one has just sold out. Please pick another.'; st.plain = null; st.rhine = null; loadPlain(); loadRhine();
        ga('nkc_error', { tab: 'teaser', error: String(e && e.message || e).slice(0, 80) }); schedule(true);
      });
  }
  function addToCart(t, d) {
    var v = variantFor(d, st.metal, st.pick);
    if (!v || st.adding) return;
    st.adding = true; st.msg = ''; schedule(true);
    var props = {}; props[LINE_PROP] = 'card';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        st.adding = false;
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'add failed');
        ga('nkc_add', { tab: t.key, variant_id: v.id, pick: st.pick, metal: st.metal, price: v.price });
        st.pick = '';
        return loadCart().then(function () {
          if (typeof window.upcartRefreshCart === 'function') { try { return window.upcartRefreshCart(); } catch (e) {} }
        });
      })
      .then(function () { schedule(true); })
      .catch(function (e) {
        st.adding = false; st.msg = 'Sorry, that one has just sold out. Please pick another.'; st.data[t.key] = null; loadProduct(t);
        ga('nkc_error', { tab: t.key, error: String(e && e.message || e).slice(0, 80) }); schedule(true);
      });
  }
  var lastSig = null;
  function matchGap(card, host) {
    try { var cs = getComputedStyle(host); var g = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.borderTopWidth) || 0); if (g) card.style.marginBottom = g + 'px'; } catch (e) {}
  }
  function paint(force) {
    var sr = root(); if (!sr) return;
    if (!sr.querySelector('#nkc-style')) { var s = document.createElement('style'); s.id = 'nkc-style'; s.textContent = CSS; sr.appendChild(s); }
    if (!sr.__nkcObs) { sr.__nkcObs = new MutationObserver(function () { schedule(); }); sr.__nkcObs.observe(sr, { childList: true, subtree: true }); }
    var card = sr.querySelector('#nkc-card');
    var m = mode();
    if (st.prevMode === 'teaser' && m === 'card') st.unlockAt = Date.now();
    st.prevMode = m;
    if (!m) { if (card) card.parentNode.removeChild(card); lastSig = null; return; }
    TABS.forEach(loadProduct);
    if (m === 'teaser') { loadPlain(); loadRhine(); }
    var anchor = sr.querySelector('.upcart-public-addons') || sr.querySelector('.upcart-internal-addons') ||
                 sr.querySelector('.upcart-public-cart-summary') || sr.querySelector('.upcart-checkout-button-container');
    if (!anchor || !anchor.parentNode) return;
    var now = sig();
    if (!card || force || now !== lastSig) {
      var fresh = m === 'teaser' ? buildTeaser() : build();
      if (!fresh) { if (card) card.parentNode.removeChild(card); lastSig = now; return; }
      var hadFocus = card && card.contains(sr.activeElement) ? sr.activeElement.className : '';
      if (card) card.parentNode.removeChild(card);
      anchor.parentNode.insertBefore(fresh, anchor); card = fresh; lastSig = now; matchGap(card, anchor.parentNode);
      if (hadFocus && !/nkc-sel|nkc-gem/.test(hadFocus)) { var f = card.querySelector('.' + String(hadFocus).split(' ')[0]); if (f && f.focus) try { f.focus(); } catch (e) {} }
      var key = m + ((st.cart && st.cart.token) || '');
      if (st.viewedFor !== key) { st.viewedFor = key; ga(m === 'teaser' ? 'nkc_teaser_view' : 'nkc_view', { tab: st.tab }); }
    } else if (card.nextSibling !== anchor) {
      anchor.parentNode.insertBefore(card, anchor); matchGap(card, anchor.parentNode);
    }
  }
  function schedule(force) {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(function () { paint(force === true); }, force === true ? 0 : 80);
  }
  function refresh() { return loadCart().then(function () { schedule(); }); }
  function bindUpcart() {
    var tries = 0;
    (function poll() {
      if (typeof window.upcartSubscribeCartUpdated === 'function') {
        ['upcartSubscribeAddedToCart', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartLoaded', 'upcartSubscribeCartOpened'].forEach(function (fn) {
          if (typeof window[fn] === 'function') { try { window[fn](function () { refresh(); }); } catch (e) {} }
        });
        return;
      }
      if (++tries > 50) return;
      setTimeout(poll, 200);
    })();
  }
  function boot() {
    if (disabled()) return;
    loadCart().then(schedule);
    bindUpcart();
    var tries = 0;
    (function poll() { if (root()) { schedule(); return; } if (++tries > 40) return; setTimeout(poll, 500); })();
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    window.nikitaPendantCard = { refresh: refresh, state: st };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
